/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 13.11.12, 09:28
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */
import { IInternalGGSTextField } from "./textfield/IInternalGGSTextField";
import { TextFormatUtil } from "./TextFormatUtil";
import { getLogger } from "@goodgamestudios/logger";
import { TEXT_FIELDS_LOGGER } from "../../../index";
import { TextFormat, TextField } from "@goodgamestudios/createjs-utilities";
const logger = getLogger(TEXT_FIELDS_LOGGER + ".FontConfigVO");


export class FontConfigVO {
    public static FONT_STYLE_REGULAR: number = 0;
    public static FONT_STYLE_BOLD: number = 1;

    public static DEBUG: boolean;
    public debugColor: string = "0x00FFAA";


    /** Holds final composed font name, e.g. CastleFonts_ru **/
    public fontName: string;  // TODO HTML5  i really dont understand this duplication of info from textFormat...

    /** fontStyle is not used yet **/
    public fontStyle: number = FontConfigVO.FONT_STYLE_REGULAR;

    /** Scale of the font. Enables to scale e.g. runtime fonts. **/
    public fontScale: number = 1;

    /** Smallest font size **/
    public fontSizeMinimum: number;

    /** Some fonts are rendered with a little y offset. Use this attribute to configure it for your needs. **/
    public yOffset: number = 0;

    /** Holds actual y position of a TextField **/
    private _y: number;

    /** Holds original y position **/
    private _yPosOriginal: number;

    /** Additional TextFormat for the loaded font. **/
    protected _textFormat: TextFormat;

    /** visibility     */
    public visible: boolean;

    public initalize(originalTextField: TextField): void {
        // this.fontName = originalTextField.defaultTextFormat.font;   WHY ARE WE GRABBING THE DEFAULT FORMAT AND NOT THE ONE THAT WAS DEFINED IN THE TEXTFIELD AND EXPORTED???  this way we loose size and color etc!!
        this.yPosOriginal = originalTextField.y;
        this.setTextFormat(originalTextField.getTextFormat()); // TODO HTML-2128  SHOULD WE CLONE IT?
        this.visible = originalTextField.visible;
    }

    public applyYOffsetToOriginalPosition(textField: IInternalGGSTextField = null): void {
        this._y = this._yPosOriginal + this.yOffset;
    }

    public setTextFormat(value: TextFormat): void {
        this._textFormat = value;
        //
        // if(this.fontName == undefined) {
        //     // TODO HTML5 HTML-2128  why is fontName undefined?
        //     this.fontName = "sans-serif";
        //   //   this.fontName = TextFormat.DEFAULT_SYSTEM_FONT;   // until createjs is released we cant use constant
        // }
        // //   TODO HTML5  why do we have the fontname - that we grab from the defaultTextFormat and assign it to the TextFormat received in param  ?
        // // Apply all values belonging the TextFormat
        // this._textFormat.font = this.fontName;
        this.fontName = this._textFormat.font;
        if (FontConfigVO.DEBUG) {
            this._textFormat.color = this.debugColor;
        }
    }

    public get textFormat(): TextFormat {
        return this._textFormat;
    }

    public toString(): string {
        return JSON.stringify(this);
        //    return "fontName: " + this.fontName + ", yOffset: " + this.yOffset + ", textFormat.font: " + this._textFormat.font + ", y: " + this._y + ", yPosOriginal: " + this._yPosOriginal + ", fontScale: " + this.fontScale + ", format.size: " + this._textFormat.size;
    }

    public get y(): number {
        return this._y;
    }

    public set yPosOriginal(value: number) {
        this._yPosOriginal = value;
        this._y = this._yPosOriginal;
    }

    public set y(value: number) {
        this._y = value;
    }

    public clone(originalFontConfig: FontConfigVO): void {
        this._y = originalFontConfig.y;
        this._yPosOriginal = originalFontConfig.yPosOriginal;
        this.setTextFormat(TextFormatUtil.cloneTextFormat(originalFontConfig.textFormat));

        if (this.fontStyle == FontConfigVO.FONT_STYLE_BOLD) {
            this._textFormat.bold = true;
        }
    }

    public get yPosOriginal(): number {
        return this._yPosOriginal;
    }

    public get debug(): boolean {
        return FontConfigVO.DEBUG;
    }

    public dispose(): void {
        this._textFormat = null;
    }
}
